import { itemCategoryActionSelectors as selector } from "../Selectors/index";
import ItemCategoryService from "../../Service/Item-master/itemCategory.service";
import { openSnackbar } from "./snackbarActions";

export const getItemCategory = () => {
  return {
    type: selector.GET_ITEM_CATEGORY,
  };
};

export const getItemCategorySuccess = (itemCategory) => {
  return {
    type: selector.GET_ITEM_CATEGORY_SUCCESS,
    payload: itemCategory,
  };
};

export const fetchItemCategory = (val) => {
  return async (dispatch) => {
    dispatch(getItemCategory());
    try {
      const res =
        val && val !== ""
          ? await ItemCategoryService.search(val)
          : await ItemCategoryService.getAll();
      dispatch(getItemCategorySuccess(res));
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };
};
